import { useMutation } from 'react-query';
import { patchConversationById } from '../../../../../conversations/src/api/patchConversationById';

interface Params {
  sessionId: string;
  riskObjectIds: string[];
}

const patchRiskObjectSelection = async ({
  sessionId,
  riskObjectIds,
}: Params) => {
  const status = await patchConversationById(sessionId, {
    select_risk_object_revision_ids: riskObjectIds,
  });
  if (status !== 200) throw new Error();
  return { status: status.toString() };
};

export const usePatchRiskObjectSelection = () => {
  return useMutation(patchRiskObjectSelection);
};
